"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      margin: theme.spacing(4, 'auto', 2.5, 'auto'),
      padding: theme.spacing(0, 4.5)
    },
    loadingTitle: {
      marginBottom: theme.spacing(2),
      borderRadius: '4px',
      width: '120px',
      height: '20px'
    },
    loadingResultTitle: {
      marginBottom: theme.spacing(1)
    },
    lastLine: {
      marginBottom: theme.spacing(2)
    }
  };
});
var _default = useStyles;
exports.default = _default;